import { CreditsPolicy } from './policy';
export function buildDefaultCreditsContext(currentUser) {
  const creditsPolicy = new CreditsPolicy(currentUser, undefined);
  return {
    creditsPolicy,
    currentUser,
    errorId: null,
    isLoaded: false
  };
}
export function olderTimestamp(timestampA, timestampB) {
  if (timestampA === undefined) {
    return timestampB;
  }
  if (timestampB === undefined) {
    return timestampA;
  }
  return Math.min(timestampA, timestampB);
}
export const convertToUnixEpoch = dateArray => {
  const [year, month, day] = dateArray;
  const date = new Date(Date.UTC(year, month - 1, day));
  const unixEpoch = Math.floor(date.getTime());
  return unixEpoch;
};